// extracted by mini-css-extract-plugin
module.exports = {"ImageX":"_3WQKx","imageX":"_3WQKx"};